import {html, css, LitElement, ref, createRef, svg, live, render, keyed} from 'lit'
import { ClientDropdown } from './client-dropdown.js'


const editIcon = svg`
<svg width="21" height="23" viewBox="0 0 21 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.349609 22.8774V18.8774H20.3496V22.8774H0.349609ZM4.34961 14.8774H5.74961L13.5496 7.10244L12.1246 5.67744L4.34961 13.4774V14.8774ZM2.34961 16.8774V12.6274L13.5496 1.45244C13.7329 1.26911 13.9454 1.12744 14.1871 1.02744C14.4288 0.927441 14.6829 0.877441 14.9496 0.877441C15.2163 0.877441 15.4746 0.927441 15.7246 1.02744C15.9746 1.12744 16.1996 1.27744 16.3996 1.47744L17.7746 2.87744C17.9746 3.06077 18.1204 3.27744 18.2121 3.52744C18.3038 3.77744 18.3496 4.03577 18.3496 4.30244C18.3496 4.55244 18.3038 4.79827 18.2121 5.03994C18.1204 5.28161 17.9746 5.50244 17.7746 5.70244L6.59961 16.8774H2.34961Z" fill="#1C1B1F"/>
</svg>
`

const applyIcon = svg`
<svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.54961 13.0001L0.849609 7.3001L2.27461 5.8751L6.54961 10.1501L15.7246 0.975098L17.1496 2.4001L6.54961 13.0001Z" fill="#1C1B1F"/>
</svg>
`

class AddressField extends LitElement {
    $input = createRef()

    static get properties() {
        return {
            "value": { type: String }
        }
    }

    conenctedCallback() {
        this.editMode = false
    }
    
    render() {
        return html`
            <input type="text" .value=${this.value} ${ref(this.$input)} maxlength="512">
            <button @click=${this.switchEdit}>${this.editMode ? applyIcon : editIcon}</button>
        `
    }

    switchEdit() {
        this.editMode = !this.editMode
        this.classList.toggle("editable")

        if (this.editMode) {
            this.$input.value.style.pointerEvents = `all`
            this.$input.value.focus()
        } else {
            this.value = this.$input.value.value
            this.$input.value.blur()
        }
        this.requestUpdate()
    }


    static get styles() {
        return css`
            :host {
                display: grid;
                grid-template-columns: 1fr 50px;
                align-items: center;
                position: relative;
                background: rgba(0, 0, 0, 0.05);
                overflow: hidden;
                height: 35px;
                border-radius: 10px;
            }

            :host input {
                pointer-events: none;
                height: 100%;
                background: none;
                border: none;
                outline: none;
                padding: 0px 15px;
            }

            :host(.editable) {
                border: 1px solid #DDDDDD;
                box-shadow: inset 0px 4px 8.9px rgba(0, 0, 0, 0.09);
            }

            :host(.editable) input {
                pointer-events: all
            }

            button {
                appearance: none;
                border: none;
                background: none;
            }
        `
    }
}

window.customElements.define("address-field", AddressField)


const personIcon = svg`
<svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.7843 11.9564C14.7946 11.9564 13.9534 11.61 13.2606 10.9172C12.5679 10.2245 12.2215 9.38329 12.2215 8.39364C12.2215 7.40398 12.5679 6.56278 13.2606 5.87003C13.9534 5.17727 14.7946 4.83089 15.7843 4.83089C16.7739 4.83089 17.6151 5.17727 18.3079 5.87003C19.0006 6.56278 19.347 7.40398 19.347 8.39364C19.347 9.38329 19.0006 10.2245 18.3079 10.9172C17.6151 11.61 16.7739 11.9564 15.7843 11.9564ZM8.65877 19.0819V16.8255C8.65877 16.4098 8.75774 16.0139 8.95567 15.6379C9.1536 15.2618 9.4307 14.9649 9.78697 14.7472C10.6777 14.2128 11.6228 13.812 12.6223 13.5448C13.6219 13.2776 14.6759 13.144 15.7843 13.144C16.8927 13.144 17.9466 13.2776 18.9462 13.5448C19.9457 13.812 20.8909 14.2128 21.7815 14.7472C22.1378 14.9649 22.4149 15.2618 22.6129 15.6379C22.8108 16.0139 22.9097 16.4098 22.9097 16.8255V19.0819H8.65877ZM0.345703 11.9564V9.58122H9.84635V11.9564H0.345703ZM0.345703 2.45573V0.0805664H14.5967V2.45573H0.345703ZM9.96511 7.20605H0.345703V4.83089H11.0339C10.7568 5.16737 10.5342 5.53354 10.3659 5.9294C10.1977 6.32526 10.0641 6.75081 9.96511 7.20605Z" fill="#1C1B1F"/>
</svg>
`

class PersonTypeField extends LitElement {
    $box = createRef()
    $dialog = createRef()

    static get properties() {
        return {
            "value": { type: String }
        }
    }

    connectedCallback() {
        super.connectedCallback()
        let template = this.querySelector("template"),
            container = document.createElement("div"),
            content = template.content.cloneNode(true)
        
        container.append(content)
        container.classList = template.classList
        this.append(container)
        template.remove()

        this.addEventListener("click", this.showDialog)
    }

    render() {
        return html`
            <button class="btn-icon">${personIcon}</button>
            <div class="type">${this.value}</div>
            <div class="box" ${ref(this.$box)}></div>
        `
    }

    showDialog() {
        let w = 400,
            h = 500

        if (window.innerWidth < window.innerHeight) {
            w = window.innerWidth
            h = window.innerHeight - 100
        }


        render(keyed(Math.random(), html`
            <dialog-box .w=${w} .h=${h} ${ref(this.$dialog)}>
                <div class="pane" style="width: ${w}px; height: ${h}px">
                    <slot></slot>
                    <button class="btn-orange" @pointerdown=${evt => {this.$dialog.value.remove(); evt.stopPropagation();} }>Закрыть</button>
                </div>
            </dialog-box>
        `), this.$box.value)
    }

    static get styles() {
        return css`
            :host {
                display: grid;
                grid-template-columns: 50px 1fr 1px;
                align-items: center;
                position: relative;
                background: rgba(0, 0, 0, 0.05);
                overflow: hidden;
                height: 40px;
                border-radius: 10px;
                height: 35px;
                cursor: pointer;
            }

            .type {
                font-weight: bold;
            }

            .btn-icon {
                display: flex;
                justify-content: center;
                align-items: center;
                appearance: none;
                border: none;
                background: none;
            }

            .pane {
               background: white;
               padding: 20px;
               overflow: auto;
               border-radius: 10px;
               background: #FFFFFF;
               box-sizing: border-box;
               box-shadow: 0px 4px 48px rgba(0, 0, 0, 0.25);
               border-radius: 10px;
               border: red;
               overflow: hidden;
               display: flex;
               flex-direction: column;
               gap: 20px;
               align-items: center;
            }

            ::slotted(*) {
                width: 100%;
                height: 100%;
                overflow: auto;
            }

            dialog-box::part(background) {
                background: rgba(0, 0, 0, 0.1);
            }

            .btn-orange {
                margin: auto;
                appearance: none;
	            border: none;
	            color: white;
	            background: linear-gradient(270.53deg, #FFB700 2.41%, #FF7A00 95.27%);
	            border-radius: 6px;
	            font-size: 15px;
	            padding: 7px;
            }
        `
    }
}

window.customElements.define("person-type-field", PersonTypeField)



class PaymentChooser extends LitElement {

    static get properties() {
        return {
            systems: {type: Object}
        }
    }

    firstUpdated() {
        let drop = new ClientDropdown(this.systems)
        this.renderRoot.append(drop)
    }

    static get styles() {
        return css`
            client-dropdown {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 100%;
            }

            client-dropdown::part(readout) {
               padding: 0px 15px;
            }

            client-dropdown::part(dropdown) {
                border-radius: 8px;
            }
        `
    }
}

window.customElements.define("payment-chooser", PaymentChooser)



class FZ152 extends LitElement {
    $box = createRef()
    $dialog = createRef()

    static get properties() {
        return {
            "title": { type: String },
        }
    }

    connectedCallback() {
        super.connectedCallback()
        let template = this.querySelector("template"),
            container = document.createElement("div"),
            content = template.content.cloneNode(true)
        
        container.append(content)
        container.classList = template.classList
        this.append(container)
        template.remove()
    }

    render() {
        return html`
            <div class="short" @click=${this.showDialog}>${this.title}</div>
            <div class="box" ${ref(this.$box)}></div>
        `
    }

    showDialog() {
        let w = window.innerWidth  * 0.8,
            h = window.innerHeight  * 0.8
        if (window.innerWidth < window.innerHeight) {
            w = window.innerWidth 
            h = window.innerHeight - 100
        }

        render(keyed(Math.random(), html`
            <dialog-box .w=${w} .h=${h} ${ref(this.$dialog)}>
                <div class="pane" style="width: ${w}px; height: ${h}px">
                    <slot></slot>
                    <button @pointerdown=${evt => {this.$dialog.value.remove(); evt.stopPropagation();} }>Согласен</button>
                </div>
            </dialog-box>
        `), this.$box.value)
    }


    static get styles() {
        return css`
            :host {
                display: flex;
                align-items: center;
                position: relative;
                cursor: pointer;
                overflow: hidden;
            }
            
            .pane {
                background: white;
                padding: 50px;
                overflow: auto;
                border-radius: 10px;
                background: #FFFFFF;
                box-sizing: border-box;
                box-shadow: 0px 4px 48px rgba(0, 0, 0, 0.25);
                border-radius: 10px;
                border: red;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                gap: 20px;
                align-items: center;
            }

            ::slotted(*) {
                width: 100%;
                height: 100%;
                overflow: auto;
            }

            dialog-box::part(background) {
                background: rgba(0, 0, 0, 0.1);
            }

            button {
                margin: auto;
                appearance: none;
	            border: none;
	            color: white;
	            background: linear-gradient(270.53deg, #FFB700 2.41%, #FF7A00 95.27%);
	            border-radius: 6px;
	            font-size: 15px;
	            padding: 7px;
            }
        `
    }
}


window.customElements.define("fz-152", FZ152)